import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ParamsModal from '../ParamsModal/ParamsModal';
import EditParamsModal from '../ParamsModal/EditParamsModal';
import VariableService from '../../../services/VariableService/VariableService';

export default function Table({ action, options, automVersionId, inputName, isRequired, setOpenVariable, isActiveDirectory = false, formData }) {
    const [open, setOpen] = useState(false)
    const [editOpen, setEditOpen] = useState(false);
    const [indexId, setIndexId] = useState(0);
    const [variable, setVariable] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const { t } = useTranslation();
    const [isControl, setIsControl] = useState([]);

    useEffect(() => {
        let y = Object.keys(action.fields)
        if (y.indexOf(inputName) === -1) {
            if (inputName !== undefined) {
                action.fields[inputName] = {};
                let x = Object.keys(action.fields[inputName])
                if (x.indexOf(inputName) === -1) {
                    action.fields[inputName] = { type: "TABLE", value: [], isRequired };
                }
            }
        }

    }, [action])

    useEffect(() => {
        if (refresh) {
            VariableService.getVariable(automVersionId)
                .then((response) => {
                    if (Array.isArray(response.data)) {
                        setVariable(response.data)
                    } else {
                        setVariable([response.data])
                    }

                })
                .catch((error) => {
                    //err
                });
            setRefresh(false);
        }
    }, [refresh]);

    useEffect(() => {
        let y = Object.keys(action.fields)
        setIsControl(y);
    }, [inputName])
    const handleClick = (index) => {
        setEditOpen(true);
        setIndexId(index);
    }
    const handleExpand = (e) => { e.target.classList.toggle('content-overflow'); }
    return (
        <div style={{ width: '100%', overflow: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>{t(options?.title)}</span>
                <IconButton style={{ padding: 0 }} onClick={() => setOpen(!open)}>
                    <AddCircleOutlineIcon style={{ paddingLeft: 5, paddingTop: 5, color: "#8C90A2" }} />
                </IconButton>
            </div>
            <table>
                <tbody>
                    <tr>
                        {options?.headers?.map((item, itemI) =>
                            <th style={{ width: itemI !== 2 && "6rem" }} key={itemI}>{t(item)}</th>
                        )}
                    </tr>

                    {(action.fields !== undefined && isControl.indexOf(inputName) !== -1 && Array.isArray(action.fields[inputName]?.value)) && action.fields[inputName].value.map((item, index) => {
                        if (!isActiveDirectory) {
                            return <tr key={index}>
                                <td style={{ width: '6rem' }}>{item.isActive ? 'Active' : 'Passive'}</td>
                                <td><span style={{ width: '6rem' }} className="content-overflow" onClick={handleExpand}>{item.name}</span></td>
                                <td><span className="content-overflow" style={{ width: 150 }} onClick={handleExpand}>{item.value}</span></td>
                                <td style={{ cursor: "pointer", width: "2rem" }} onClick={() => handleClick(index)}><CreateIcon
                                    style={{ width: "20px", height: "20px", marginTop: "0.2rem" }}
                                /></td>
                            </tr>
                        }
                        else {
                            return <tr key={index}>
                                <td style={{ width: "100%" }}> {item.value}</td>
                                <td style={{ cursor: "pointer", maxWidth: "2rem" }} onClick={() => handleClick(index)}><CreateIcon
                                    style={{ width: "20px", height: "20px", marginTop: "0.2rem" }}
                                /></td>
                            </tr>
                        }
                    })}
                </tbody>
            </table>
            {open && (
                <ParamsModal
                    action={action} title={t(options?.title)}
                    variable={variable}
                    setOpen={setOpen}
                    setRefresh={setRefresh}
                    setOpenVariable={setOpenVariable}
                    inputName={inputName}
                    isActiveDirectory={isActiveDirectory}
                    formData={formData}
                />
            )}
            {editOpen && (
                <EditParamsModal
                    action={action} title={t(options?.title)}
                    variable={variable}
                    setOpen={setEditOpen}
                    indexId={indexId}
                    setRefresh={setRefresh}
                    setOpenVariable={setOpenVariable}
                    inputName={inputName}
                    isActiveDirectory={isActiveDirectory}
                    formData={formData}
                />
            )}
        </div>
    );
}
